import { useRef, useState, useEffect } from 'react';
import './ProfileImageUploader.scss';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { profileImageUploaderI18n } from './i18n';

const DEFAULT_ACCEPT = 'image/jpeg,image/png,image/webp';

const ProfileImageUploader = ({
  value, // string | null → url actual
  onChange, // (file: File | null) => void
  size = 72, // tamaño del avatar (px)
  disabled = false,
  accept = DEFAULT_ACCEPT,
}) => {
  const { t } = useScopedTranslation(profileImageUploaderI18n);
  const inputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  /* =========================
     Preview desde archivo
  ========================== */
  useEffect(() => {
    if (!previewUrl) return;
    return () => URL.revokeObjectURL(previewUrl);
  }, [previewUrl]);

  const handleSelectFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    onChange?.(file);
  };

  const handleClick = () => {
    if (!disabled) inputRef.current?.click();
  };

  const imageSrc = previewUrl || value || null;

  return (
    <div className='profile-image-uploader'>
      <div
        className='avatar'
        style={{ width: size, height: size }}
        onClick={handleClick}
        role='button'
        aria-disabled={disabled}
      >
        {imageSrc ? (
          <img src={imageSrc} alt={t('pf_profilePhoto')} />
        ) : (
          <span className='placeholder'>{t('pf_noPhoto')}</span>
        )}
      </div>

      <div className='actions'>
        <button
          type='button'
          className='change-btn'
          onClick={handleClick}
          disabled={disabled}
        >
          {t('pf_changePhoto')}
        </button>

        <input
          ref={inputRef}
          type='file'
          accept={accept}
          onChange={handleSelectFile}
          hidden
        />
      </div>
    </div>
  );
};

export default ProfileImageUploader;
